













// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { DashmixNavTabsProps } from './NavTabs.contracts'
import { dashmixNavTabsProps, useDashmixNavTabs } from './NavTabs.hooks'
import { DashmixNavTabsItem } from './_partials'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixNavTabs = defineComponent({
  name: 'DashmixNavTabs',
  components: { DashmixNavTabsItem },
  props: dashmixNavTabsProps,
  emits: ['update:activeItem'],

  setup (props: DashmixNavTabsProps, ctx: SetupContext) {
    return useDashmixNavTabs(props, ctx)
  }
})

export default DashmixNavTabs
